import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  text: {
    alignItems: 'center',
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    borderRadius: ({ borderRadius }) => `${borderRadius}px`,
    color: ({ color }) => color,
    display: 'inline-flex',
    fontSize: ({ size }) => {
      switch (size) {
      case 'large':
        return '1.25rem'
      case 'medium':
        return '1.00rem'
      case 'small':
        return '.60rem'
      default:
        return '0.75rem'
      }
    },
    height: '2em',
    justifyContent: 'center',
    lineHeight: 1.5,
    paddingLeft: '0.75em',
    paddingRight: '0.75em',
    textTransform: ({ isUpperCased }) => isUpperCased ? 'uppercase' : 'initial',
    whiteSpace: 'nowrap'
  }
})

export default useStyles
